import React from "react";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import MapIcon from "@mui/icons-material/Map";
import SettingsInputAntennaIcon from "@mui/icons-material/SettingsInputAntenna";
import KitchenIcon from "@mui/icons-material/Kitchen";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import PoolIcon from "@mui/icons-material/Pool";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import ChairIcon from "@mui/icons-material/Chair";
import WaterIcon from "@mui/icons-material/Water";
import SettingsIcon from "@mui/icons-material/Settings";
import DeckIcon from "@mui/icons-material/Deck";
import WifiIcon from "@mui/icons-material/Wifi";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import FireplaceIcon from "@mui/icons-material/Fireplace";
import CableIcon from "@mui/icons-material/Cable";
import BathroomIcon from "@mui/icons-material/Bathroom";
import ShowerIcon from "@mui/icons-material/Shower";
import MicrowaveIcon from "@mui/icons-material/Microwave";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import AnchorIcon from "@mui/icons-material/Anchor";
import SpeakerIcon from "@mui/icons-material/Speaker";
import AlbumIcon from "@mui/icons-material/Album";
import ConstructionIcon from "@mui/icons-material/Construction";
import SailingIcon from "@mui/icons-material/Sailing";
import AirIcon from "@mui/icons-material/Air";
import TableBarIcon from "@mui/icons-material/TableBar";

type IconEntry = [string[], React.ReactElement];

const iconMap: IconEntry[] = [
  [["autopilot"], <GpsFixedIcon fontSize="small" />],
  [["chart plotter", "chartplotter"], <MapIcon fontSize="small" />],
  [["vhf", "radio"], <SettingsInputAntennaIcon fontSize="small" />],
  [["refrigerator", "fridge"], <KitchenIcon fontSize="small" />],
  [["solar"], <WbSunnyIcon fontSize="small" />],
  [["snorkel"], <PoolIcon fontSize="small" />],
  [["bimini"], <BeachAccessIcon fontSize="small" />],
  [["dinghy"], <DirectionsBoatIcon fontSize="small" />],
  [["cushion"], <ChairIcon fontSize="small" />],
  [["holding tank"], <WaterIcon fontSize="small" />],
  [["bow thruster"], <SettingsIcon fontSize="small" />],
  [["teak"], <DeckIcon fontSize="small" />],
  [["wi-fi", "wifi"], <WifiIcon fontSize="small" />],
  [["air condition", " ac "], <AcUnitIcon fontSize="small" />],
  [["generator"], <ElectricBoltIcon fontSize="small" />],
  [["heat"], <FireplaceIcon fontSize="small" />],
  [["winch", "windlass"], <CableIcon fontSize="small" />],
  [["toilet"], <BathroomIcon fontSize="small" />],
  [["shower"], <ShowerIcon fontSize="small" />],
  [["microwave"], <MicrowaveIcon fontSize="small" />],
  [["depth sounder", "depth finder"], <SignalCellularAltIcon fontSize="small" />],
  [["life raft"], <HealthAndSafetyIcon fontSize="small" />],
  [["anchor"], <AnchorIcon fontSize="small" />],
  [["speaker"], <SpeakerIcon fontSize="small" />],
  [["cd player", "radio-cd"], <AlbumIcon fontSize="small" />],
  [["construction", "crane"], <ConstructionIcon fontSize="small" />],
  [["spinnaker", "gennaker"], <AirIcon fontSize="small" />],
  [["sail"], <SailingIcon fontSize="small" />],
  [["cockpit"], <TableBarIcon fontSize="small" />],
];

export function getEquipmentIcon(name: string): React.ReactElement | null {
  if (!name) return null;
  const lower = ` ${name.toLowerCase()} `;
  for (const [keywords, icon] of iconMap) {
    if (keywords.some((kw) => lower.includes(kw))) {
      return icon;
    }
  }
  return null;
}
